import { render, staticRenderFns } from "./MitPeopleSearch.vue?vue&type=template&id=72180aa6&scoped=true"
import script from "./MitPeopleSearch.vue?vue&type=script&lang=js"
export * from "./MitPeopleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72180aa6",
  null
  
)

export default component.exports